/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

<template>
  <div v-bind:class="amplifyUI.formSection">
    <div v-bind:class="amplifyUI.sectionHeader">{{options.header}}</div>
    <div v-bind:class="amplifyUI.sectionBody">
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Code')}} *</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="code"
          :placeholder="$Amplify.I18n.get('Code')"
          v-on:keyup.enter="submit"
        />
      </div>
    </div>
    <div v-bind:class="amplifyUI.sectionFooter">
      <span v-bind:class="amplifyUI.sectionFooterPrimaryContent">
        <button
          v-bind:class="amplifyUI.button"
          v-on:click="submit"
          :disabled="!code"
        >{{$Amplify.I18n.get('Confirm')}}</button>
      </span>
      <span v-bind:class="amplifyUI.sectionFooterSecondaryContent">
        <a v-bind:class="amplifyUI.a" v-on:click="signIn">{{$Amplify.I18n.get('Back to Sign In')}}</a>
      </span>
    </div>
    <div class="custom-error" v-if="error">{{ error }}</div>
  </div>
</template>


<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import * as AmplifyUI from "@aws-amplify/ui";
import { mapState } from "vuex";

export default {
  name: "ConfirmSignIn",
  props: ["confirmSignInConfig"],
  data() {
    return {
      verifyAttr: "",
      code: "",
      error: "",
      logger: {},
      amplifyUI: AmplifyUI,
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    options() {
      const defaults = {
        header: this.$Amplify.I18n.get("Confirm Sign In"),
        user: {},
      };
      return Object.assign(defaults, this.confirmSignInConfig || {});
    },
  },
  mounted() {
    // this.logger = new this.$Amplify.Logger(this.$options.name);
    // if (Object.keys(this.options.user).length === 0) {
    //   this.setError("Valid user not received.");
    // }
  },
  methods: {
    submit: function () {
      this.$Amplify.Auth.confirmSignIn(
        this.user,
        this.code,
        this.user.challengeName
      )
        .then(async (data) => {
          //   this.logger.info("confirmSignIn successs");
          // create AWS MFA log
          await this.$store.dispatch("user/createLog", {
            username: this.user.username,
            log: "AWSMfa",
            app: "MyAlerus",
          });
          return AmplifyEventBus.$emit("authState", "signedIn");
        })
        .catch((e) => {
          if (e.name === "CodeMismatchException") {
            // create failed AWS MFA log
            this.$store.dispatch("user/createLog", {
              username: this.user.username,
              log: "AWSMfaFail",
              app: "MyAlerus",
            });
            this.error = "Invalid code.";
          } else {
            this.setError(e);
          }
        });
    },
    signIn: function () {
      this.$store.commit("user/setAWSMfa", false);
      AmplifyEventBus.$emit("authState", "signedOut");
    },
    setError: function (e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      //   this.logger.error(this.error);
    },
  },
};
</script>

<style lang="scss">
.custom-error {
  color: red;
}
</style>